<template>
    <div class="form-group form0" :class="{'has-error': validation.hasError('mirror')}">
        <div class="input-group input-group-sm">
            <datepicker ref="programaticOpen" :format="format" :value="modelo.fecha" @input="fechaSelect" :typeable="true" :clear-button="true" :language="espanol" placeholder="Formato DD/MM/YYYY"></datepicker>
            <!-- <input type="tel" v-model.trim="modelo.fecha" class="form-control" placeholder="Formato DD/MM/YYYY">
            <div class="input-group-addon" @click="openPicker"> {{model.fecha}} </div> -->
        </div>
        <div class="error" v-if="validation.hasError('mirror')"> {{validation.firstError('mirror')}} </div>
        <!-- <small> {{mirror}} </small>  -->
    </div>
</template>

<script>
//import Datepicker from 'vuejs-datepicker'
import Datepicker from '@hokify/vuejs-datepicker';
import { Validator } from 'simple-vue-validator';
import "@hokify/vuejs-datepicker/dist/vuejs-datepicker.css"; // include CSS
//import {mask} from 'vue-the-mask'
export default {
    props:{ model:Object,valueto:{type:String,required:false,default:null },default:{type:String,required:false,default:null} },
    data(){
        return{
            espanol: 'es',
            format: "DD/MM/YYYY",
            mirror: null, // permite validar la fecha, pero no es la que se usa
            datos: [],
            modelo: {
                fecha: null,
            }
        }
    },
    //directives: {mask},
    components:{Datepicker},
    watch:{
        'default': function(){
            this.parseDefault();
        },
    },
    validators: {
        'modelo.fecha'(value){
            return Validator.value(value).regex('^[0-9]{2}/[0-9]{2}/[0-9]{4}$');
        },
        'mirror'(value){
            return Validator.value(value).regex('^[0-9]{4}-[0-9]{2}-[0-9]{2}$'); // al server anio-mes-dia
        }
    },
    methods:{
        openPicker() {
            this.$refs.programaticOpen.showCalendar();
        },
        customFormatter(date) {
            return this.$moment(date).format('dd/MM/yyyy');
        },
        fechaSelect(dat){
            var date = dat;
            if( !date ) return;
            var d = date.getDate()+1;
            var m = date.getMonth()+1;
            var a = date.getFullYear();
            if( d < 10 ) d = '0'+d;
            if( m < 10 ) m = '0'+m;
            var fec = a+"-"+m+"-"+d;
            window.console.log( "fechaSelect ",fec );
            if( this.valueto ) this.model[this.valueto] = fec;
            else this.model.fecha = fec;
            this.mirror = fec; // para mostrar la fecha 
        },
        parseDefault(){
            if( this.default ) {
                var ps = this.default.split("-");
                var def = ps[1]+"/"+ps[2]+"/"+ps[0];
                this.modelo.fecha = def;
                if( this.valueto ) this.model[this.valueto] = ps[0]+"-"+ps[1]+"-"+ps[2];
                else this.model.fecha = ps[0]+"-"+ps[1]+"-"+ps[2];
            }
        }
    },
    mounted(){
        this.$validate().then(() => {  });        
        this.parseDefault();
    }
}
</script>